import "./ExitStrategy.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ThePathToFreedom from "./sections/ThePathToFreedom";
import GetYourExitAssessment from "./sections/GetYourExitAssessment";
import FooterLegal from "@/reusable_sections/Footer";
import StartYourAssessment from "./sections/StartYourAssessment";
export default function ExitStrategyPage() {
  return <div>
      <MainNavigation />
      <StartYourAssessment />
      <ThePathToFreedom />
      <GetYourExitAssessment />
      <FooterLegal />
    </div>;
}